export const SOCIAL_POST_CAPTIONS_POLL_ID =
  'app/download/social-post-captions-poll-id';

export const VIDEO_SOCIAL_POST_CAPTIONS_POLL_ID =
  'app/download/video-social-post-captions-poll-id';

export const EMBED_VIDEO_SOCIAL_POST_CAPTIONS_POLL_ID =
  'app/download/embed-video-social-post-captions-poll-id';
